const NAMESPACE = "incentiveOptionsTab";

const KEYS = {
    approvalStatusLabel: "approvalStatusLabel",
    noSelectedApprovalStatusText: "noSelectedApprovalStatusText",
    approvalStatusDescriptionText: "approvalStatusDescriptionText",
    setApprovalStatusLabel: "setApprovalStatusLabel",
    noApprovalStatusOption: "noApprovalStatusOption",
    initSelectedStatusButtonText: "initSelectedStatusButtonText",
    setApprovalStatusButtonText: "setApprovalStatusButtonText",
    metadataSectionHeader: "metadataSectionHeader",
    metadataCountLimitText: "metadataCountLimitText",
    addMetadataFieldButtonText: "addMetadataFieldButtonText",
    emptyMetadataTableText: "emptyMetadataTableText",
    editMetadataButtonText: "editMetadataButtonText",
    deleteMetadataButtonText: "deleteMetadataButtonText"
};

const MESSAGES = {
    [KEYS.approvalStatusLabel]: {
        value: "Incentive Approval Status:",
        comment: "Label for the display of the selected Incentive Approval Status"
    },
    [KEYS.noSelectedApprovalStatusText]: {
        value: "(none)",
        comment: "Description displayed when no Approval Status has been selected"
    },
    [KEYS.approvalStatusDescriptionText]: {
        value:
            "Upon a project's first entry into the Approval Status, that project's incentive amount(s) will be considered Approved." +
            " If a project has an Approved Incentive Amount, any subsequent recalculation of incentives which have been configured to be" +
            " limited to the Approved Amount will be capped by the Approved Amount." +
            " The new incentive amount may not exceed that project's previous Approved Amount.  Setting an Approval Status is not required.",
        comment: "Description of the Approval Status displayed next to its input"
    },
    [KEYS.setApprovalStatusLabel]: {
        value: "Set the Approval Status:",
        comment: "Label for the dropdown list used to set an Approval Status"
    },
    [KEYS.noApprovalStatusOption]: {
        value: "No Incentive Approval Status selected",
        comment:
            "Option used to indicate no Incentive Approval Status has been selected in the Approval Status dropdown list"
    },
    [KEYS.initSelectedStatusButtonText]: {
        value: "Cancel",
        comment: "Text on button used to set the Approval Status selector to the current Approval Status"
    },
    [KEYS.setApprovalStatusButtonText]: {
        value: "Save",
        comment: "Text on button used to set the Approval Status"
    },
    [KEYS.metadataSectionHeader]: {
        value: "Incentive Metadata Fields",
        comment: "Header text for the Incentive Metadata section of the Incentive Design Options tab"
    },
    [KEYS.metadataCountLimitText]: {
        value: "Incentive Metadata is limited to 3 data fields.",
        comment: "Text indicating the maximum number of Incentive Metadata fields"
    },
    [KEYS.addMetadataFieldButtonText]: {
        value: "Add Metadata Field",
        comment: "Label text for the button used to add an Incentive Metadata Field"
    },
    [KEYS.emptyMetadataTableText]: {
        value: "No incentive metadata fields defined.",
        comment: "Text for the empty Incentive Metadata Fields table"
    },
    [KEYS.editMetadataButtonText]: {
        value: "Edit Metadata Field",
        comment: "Text for the button used to edit an Incentive Metadata field"
    },
    [KEYS.deleteMetadataButtonText]: {
        value: "Delete Metadata Field",
        comment: "Text for the button used to delete an Incentive Metadata field"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
